module.exports = __webpack_public_path__ + "static/img/miBookInter.c4115e6d.png";